import styled, { css } from 'styled-components'
import { Flex } from 'components'

export const Footer = styled(Flex)(
  ({ show }) => css`
    pointer-events: ${!show && 'none'};
  `,
)
